export type DatePickerType = 'date' | 'datetime' | 'month' | 'time'

export type DatePickerValue = Date | string

export const getDefaultFormat = (type: DatePickerType) => {
	if (type === 'datetime') {
		return 'yyyy-MM-dd HH:mm:ss'
	} else if (type === 'time') {
		return 'HH:mm:ss'
	} else if (type === 'month') {
		return 'yyyy-MM'
	} else {
		return 'yyyy-MM-dd'
	}
}
